/* eslint-disable arrow-spacing */
export default {
  stocks: (state) => {
    const { stocks } = state;
    const { currencies } = state;
    if (currencies.length) {
      Object.keys(stocks).forEach((stock) => {
        if (
          stocks[stock] &&
          stocks[stock].accounts &&
          stocks[stock].accounts.length
        ) {
          stocks[stock].accounts.forEach((account, index) => {
            // eslint-disable-next-line
            currencies.forEach((currency) => {
              if (
                account.currency.toLowerCase() === currency.id.toLowerCase()
              ) {
                stocks[stock].accounts[index].currentRate =
                  currency.currentRate;
                stocks[stock].accounts[index].fullTitle = currency.fullTitle;
                return false;
              }
            });
          });
        }
      });
    }
    if (currencies.length) {
      Object.values(stocks).forEach((stock) => {
        if (stock.accounts && stock.accounts.length) {
          const zeroBalance = stock.accounts
            .filter((account) => parseFloat(account.balance) === 0)
            .sort((a, b) => a.currency.localeCompare(b.currency));
          const positiveBalance = stock.accounts
            .filter((account) => parseFloat(account.balance) !== 0)
            .sort(
              (a, b) => b.currentRate * b.balance - a.currentRate * a.balance
            );
          // eslint-disable-next-line
          stock.accounts = positiveBalance.concat(zeroBalance);
        }
      });
    }

    return stocks;
  },
  userInfo: (state) => state.userInfo,
  cart: (state) => state.cart,
  initialCart: (state) => state.initialCart,
  conversionInfo: (state) => state.conversionInfo,
  txs: (state) => state.txs,
  stores: (state) => state.stores,
  extensionHeight: (state) => state.extensionHeight,
  settings: (state) => state.settings,
  currencies: (state) => state.currencies,
  displayCurrency: (state) => state.displayCurrency,
  marketInfo: (state) => state.marketInfo,
  allStocks: (state) => state.allStocks,
  paymentOptions: (state) => {
    JSON.stringify(state);
    return state.paymentOptions;
  },
  isLogoutCheckUp: (state) => state.isLogin,
  getStockExchanges: (state) => state.stockExchanges,
  getSelectedExchange: (state) => state.selectedExchange,
  bankAccount: (state) => state.bankAccount,
  tab: (state) => state.tab,
  getSocketResponse: (state) => state.socketResponse,
  getRedirectUrl: (state) => state.redirectUrl,
  getGlobalIframeRedirect: (state) => state.enableGlobalIframeRedirect,
  getMerchantIframeRedirect: (state) => state.enableMerchantIframeRedirect,
  getEnableDashboard: (state) => state.enableDashboard,
  getIsLoginWithoutEmail: (state) => state.isLoginWithoutEmail,
  getCryptoWalletStep: (state) => state.cryptoWalletStep,
  getIsIframeOpenEmitted: (state) => state.isIframeOpenEmitted,
  iframeDismissConfirmVisible: (state) => state.iframeDismissConfirmVisible,
  sessionNotifyStatus: (state) => state.sessionNotifyStatus,
  getHostedPageId: (state) => state.hostedPageId,
  getResultPageData: (state) => state.resultPageData,
  getFeedbackState: (state) => state.showFeedback,
  getRefrenceId: (state) => state.refrenceId,
  getEnrolledInRewards: (state) =>
    state.rewardsOptInPending
      ? { ...(state.enrolledInRewards || {}), optIn: true }
      : state.enrolledInRewards,
  getRewardModal: (state) => state.showRewardModal,
  getEstimatedRewards: (state) => state.estimatedRewards,
  getRewardsBalance: (state) => state.rewardsBalance,
  getContinuedTransaction: (state) => state.continuedTransaction,
  getFsStatus: (state) => state.fsStatus,
};
